<template>
  <form class="search-container" @submit.prevent>
    <v-card class="search-card" max-width="820" outlined>
      <!-- Tabs -->
      <v-tabs
        v-model="tab"
        background-color="grey lighten-4"
        color="primary"
        grow
        height="48"
      >
        <v-tab>شماره تلفن</v-tab>
        <v-tab>کد سخت‌افزاری</v-tab>
        <v-tab>نام دستگاه</v-tab>
      </v-tabs>

      <v-divider />

      <v-card-text class="pt-6">
        <v-tabs-items v-model="tab">
          <!-- Phone -->
          <v-tab-item>
            <v-row align="center" class="py-1" dense>
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="phone"
                  label="شماره تلفن"
                  prepend-inner-icon="mdi-phone"
                  outlined
                  dense
                  hide-details
                  clearable
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-btn
                  block
                  height="44"
                  color="primary"
                  elevation="0"
                  :disabled="!phone"
                  :loading="loading"
                  @click="searchByPhone"
                >
                  جستجو
                </v-btn>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- Hardware -->
          <v-tab-item>
            <v-row align="center" class="py-1" dense>
              <v-col md="8">
                <v-text-field
                  v-model="hardware"
                  label="کد سخت‌افزاری"
                  prepend-inner-icon="mdi-chip"
                  outlined
                  dense
                  hide-details
                  clearable
                />
              </v-col>

              <v-col md="4">
                <v-btn
                  block
                  height="44"
                  color="primary"
                  elevation="0"
                  :disabled="!hardware"
                  :loading="loading"
                  @click="searchByHardware"
                >
                  جستجو
                </v-btn>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- Name -->
          <v-tab-item>
            <v-row align="center" class="py-1" dense>
              <v-col md="8">
                <v-text-field
                  v-model="name"
                  label="نام دستگاه"
                  prepend-inner-icon="mdi-devices"
                  outlined
                  dense
                  hide-details
                  clearable
                />
              </v-col>

              <v-col md="4">
                <v-btn
                  block
                  height="44"
                  color="primary"
                  elevation="0"
                  :disabled="!name"
                  :loading="loading"
                  @click="searchByName"
                >
                  جستجو
                </v-btn>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <!-- Table -->
      <v-divider v-if="hasData" />

      <v-data-table
        v-if="hasData"
        :headers="
          tab === 0 ? headersPhone : tab === 1 ? headersHardware : headersName
        "
        :items="logs"
        :loading="loading"
        dense
        class="search-table"
        loading-text="در حال بارگذاری..."
        no-data-text="موردی یافت نشد"
      >
        <template v-if="tab > 0" v-slot:item.complex="{ item }">
          <a
            class="complex-link"
            @click="goToComplex(item.complexId, item.complex)"
          >
            {{ item.complex }}
          </a>
        </template>
        <template v-if="tab > 0" v-slot:item.device="{ item }">
          <a
            class="complex-link"
            @click="goToDevice(item.deviceId, item.complex)"
          >
            {{ item.device }}
          </a>
        </template>
      </v-data-table>
    </v-card>
  </form>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "LogSearch",

  data() {
    return {
      tab: 0,
      loading: false,
      hasData: false,

      phone: null,
      hardware: null,
      name: null,

      logs: [],

      headersPhone: [
        { text: "مجموعه", value: "complex" },
        { text: "دستگاه", value: "device" },
        { text: "شماره", value: "phone" },
        { text: "زمان", value: "time" },
        { text: "آخرین وضعیت", value: "lastSate" }
      ],

      headersHardware: [
        { text: "مجموعه", value: "complex" },
        { text: "دستگاه", value: "device" },
        { text: "کد سخت‌افزاری", value: "hardwareCode" }
      ],

      headersName: [
        { text: "مجموعه", value: "complex" },
        { text: "دستگاه", value: "device" },
        { text: "کد سخت‌افزاری", value: "hardwareCode" }
      ]
    };
  },

  watch: {
    tab() {
      this.reset();
    }
  },

  methods: {
    reset() {
      this.logs = [];
      this.hasData = false;
      this.loading = false;
      this.phone = null;
      this.hardware = null;
    },

    async searchByPhone() {
      if (!this.phone) return;

      this.loading = true;
      this.hasData = false;

      try {
        const res = await request.get(`/DeviceManagement/search/${this.phone}`);
        const data = res.data.result;
        this.logs = Array.isArray(data) ? data : [];
        this.hasData = true;
      } catch {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },

    async searchByHardware() {
      if (!this.hardware) return;

      this.loading = true;
      this.hasData = false;

      try {
        const res = await request.get(
          `/DeviceManagement/search/${this.hardware}/hardware`
        );
        const data = res.data.result;
        this.logs = Array.isArray(data) ? data : [];
        this.hasData = true;
      } catch {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },

    goToComplex(complexId, complexName) {
      this.$store.commit("setSelectedComplexName", complexName);
      this.$router.push(`/complex-devices/${complexId}`);
    },
    goToDevice(deviceId, complexName) {
      this.$store.commit("setSelectedComplexName", complexName);
      this.$router.push(`/device-summary/${deviceId}`);
    },

    async searchByName() {
      if (!this.name) return;

      this.loading = true;
      this.hasData = false;

      try {
        const res = await request.get(
          `/DeviceManagement/search/${this.name}/name`
        );
        const data = res.data.result;
        this.logs = Array.isArray(data) ? data : [];
        this.hasData = true;
      } catch {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.search-container {
  display: flex;
  justify-content: center;
  align-items: center; /* 👈 وسط عمودی */
  min-height: 75vh;
}

.search-card {
  border-radius: 12px;
  overflow: visible;
}

/* Table */
.search-table {
  border-radius: 0 0 12px 12px;
}

.search-table th {
  background-color: #f5f7fa !important;
  font-weight: 600;
  text-align: center;
}

.search-table td {
  text-align: center;
}

/* Button */
.v-btn {
  border-radius: 8px;
  text-transform: none;
}

/* حذف hover مسخره */
.v-btn:hover {
  transform: none;
}

.complex-link {
  color: #1976d2;
  text-decoration: none;
  cursor: pointer;
  font-weight: 500;
}

.complex-link:hover {
  text-decoration: underline;
}
</style>
